import React from "react";
import Routes from "./Routes";
import ErrorBoundary from './components/ErrorBoundary';
import OfflineModeIndicator from './components/OfflineModeIndicator';
import QueueStatusIndicator from './components/QueueStatusIndicator';

function App() {
  return (
    <ErrorBoundary>
      <OfflineModeIndicator />
      <Routes />
      <QueueStatusIndicator />
    </ErrorBoundary>
  );
}

export default App;
